import { Tabs, type TabsProps } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import { ModalContentWrapper } from './info-modal.style';
import { OverviewModalContent } from './overview-modal-content.component';

const InfoModal = () => {
  const [t] = useTranslation();

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: t('pages.regional_overview.regional_risk.tabs.overview'),
      children: <OverviewModalContent />
    },
    {
      key: '2',
      label: t('pages.regional_overview.regional_risk.tabs.statistics'),
      children: (
        <ModalContentWrapper>
          <Trans
            i18nKey='pages.regional_overview.regional_risk.tabs.modal.content.statistics'
            components={{
              br: <br />,
              strong: <strong />
            }}
          />
        </ModalContentWrapper>
      )
    }
  ];

  return <Tabs defaultActiveKey='1' items={items} />;
};

export default InfoModal;
